/* eslint-disable no-console, no-eval, react/no-danger */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import { getDynamicImage, SHOW_DETAIL_CAST_ROUND_THUMBNAIL_IMAGE } from 'helpers/ImageHelper';
import { fetchBioDetail } from 'screens/SeriesDetail/components/Bio/BioActions';
import {
  getPurifyConfig,
  IFRAME_TEST_PATTERN,
  SCRIPT_TEST_PATTERN,
} from 'components/Article/ArticleHelpers';
import Style from './CastDetail.module.scss';

const CastInitials = info => {
  let initials = '';
  if (info.name) {
    initials = info.name.match(/\b\w/g) || [];
    initials = initials.join('').toUpperCase();
  }
  return (
    <div className={Style.missingCastImage}>
      <div className={Style.castInitials}>{initials}</div>
    </div>
  );
};

const CastDetail = ({
  accessToken,
  breakpoint,
  isModal = false,
  detail = {},
  prevArrow,
  nextArrow,
}) => {
  const { id } = detail;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchBioDetail(id, accessToken));
  }, [detail, accessToken, dispatch, id]);

  const handleEmbedScripts = articleBody => {
    const script = SCRIPT_TEST_PATTERN.exec(articleBody);
    try {
      if (window && script && script[1]) window.eval(script[1]);
    } catch (e) {
      console.debug('Embed Script error: ', e);
    }
    return script && script[0] ? articleBody.replace(script[0], '') : articleBody;
  };
  const imageUrl = _.get(detail, 'images.bioDetail');
  const bioAltText = _.get(detail, 'images.altText');
  const dynamicImageUrl = getDynamicImage({
    breakpoint,
    context: SHOW_DETAIL_CAST_ROUND_THUMBNAIL_IMAGE,
    url: imageUrl,
  });
  const image = imageUrl ? (
    <img className={Style.castImage} src={dynamicImageUrl} alt={bioAltText} />
  ) : (
    CastInitials(detail)
  );
  const imageClass = imageUrl ? Style.imageButton : Style.missingImageButton;
  const { characterName, longBio, name } = detail;
  let sanitizedBio = handleEmbedScripts(longBio);
  if (!IFRAME_TEST_PATTERN.test(longBio)) {
    sanitizedBio = DOMPurify.sanitize(longBio, getPurifyConfig());
  }
  return (
    <div className={isModal ? Style.modal : ''}>
      <div className={Style.castImageContainer}>
        {prevArrow}
        <div className={imageClass}>{image}</div>
        {nextArrow}
      </div>
      {isModal ? (
        <div className={Style.actorName}>{name}</div>
      ) : (
        <h1 className={Style.actorName}>{name}</h1>
      )}
      <div className={Style.characterName}>{characterName}</div>
      <div className={Style.bio} dangerouslySetInnerHTML={{ __html: sanitizedBio }} />
    </div>
  );
};

CastDetail.propTypes = {
  accessToken: PropTypes.string,
  breakpoint: PropTypes.string,
  detail: PropTypes.shape({}),
  isModal: PropTypes.bool,
  prevArrow: PropTypes.shape({}),
  nextArrow: PropTypes.shape({}),
};

export default CastDetail;
